import React from "react";
import InputField from "components/atoms/InputField/InputField";

interface SpecificationAdditionalFieldProps {
  placeholder: string;
  isRequired: boolean;
}

function SpecificationAdditionalField({ placeholder, isRequired }: SpecificationAdditionalFieldProps) {
  return (
    <div className="flex-row packing-list-add-item-input-large" style={{ marginTop: placeholder ? 0 : 23 }}>
      <InputField
        type="textinput"
        label={placeholder}
        placeholder={placeholder}
        field_id="additional_field"
        required={isRequired}
        validations={{ shouldUnregister: true }}
        labelClassName="text-wrap"
      />
    </div>
  );
}

export default SpecificationAdditionalField;
